class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('.js-mv-news').each(function() {
      var $text = $(this).find('p');
      if ($text.text().length >= 44) {
        $(this).addClass('is-active'); 
      }
    });
  }
}